import Destacat from 'components/3catinfo/Destacat';
import styles from '../cosNoticia.module.scss';

const NoticiaRelacionada = (props) => {
    const { id, src, alt, href, titol } = props;
    const noticia = {
        id: id,
        titol: titol,
        imatgeSrc: src,
        imatgeAlt: alt,
        href: href
    };

    return (
        <div className={styles.noticiaRelacionada} data-testid='cos-noticia-noticia-relacionada'>
            <Destacat
                estil='relacionada'
                key={`noticia-relacionada-${noticia.id}`}
                {...noticia}
                item={noticia}
                format='horitzontal'
            />
        </div>
    );
};

export default NoticiaRelacionada;
